import TomSelect from "tom-select/base";
import {industries} from '../data/industries';
import {applications} from '../data/applications';

// Import the TomSelect plugin
import TomSelect_remove_button from 'tom-select/plugins/remove_button/plugin.js';

TomSelect.define('remove_button', TomSelect_remove_button);
export const options = () => {
  // Add required on all fields


  const industry_select = document.querySelector(`#industry`);
  const sector_select = document.querySelector(`[name="00N0600000LfEBI"]`);
  const application_select = document.querySelector(`[name="00N0600000LfECO"]`);
  if (!industry_select || !sector_select || !application_select) {
    return;
  }
  sector_select.setAttribute('disabled', '');
  application_select.setAttribute('disabled', '');


  document.querySelectorAll(`[multiple="multiple"]`).forEach(select => {
    const tom = new TomSelect(select, {
      plugins: ['remove_button'],
      maxOptions: null,
    });
  });

  /**
   * Use sector select first to filter industry select and application select
   */
  industry_select.addEventListener('change', () => {

    if (industry_select.value === '') {
      enableAllOptions(sector_select);
      enableAllOptions(application_select);
      // industry_select.querySelector(`option:first-child`).setAttribute('selected', '');
      // industry_select.setAttribute('disabled', '');
      // application_select.setAttribute('disabled', '');
      // application_select.tomselect.disable();
      // application_select.tomselect.clear(); // unselect previously selected elements
      // application_select.tomselect.clearOptions(); // remove existing options
      // application_select.tomselect.sync(); // synchronise with the underlying SELECT
      return;
    }

    enableAllOptions(sector_select);

    sector_select.removeAttribute('disabled');
    console.log('---industry_select---', industry_select.value);
    const sectors = getSectors(industry_select.value);
    if (sectors.length > 0) {
      sector_select.removeAttribute('disabled');
      console.log(sectors,'---sectors---');
      sector_select.querySelectorAll('option').forEach(option => {

        if (sectors.indexOf(option.value) === -1) {
          option.setAttribute('disabled', '');
          option.setAttribute('hidden', '');
        }
      });

      // If the number of option is 1, select it
      const options = sector_select.querySelectorAll('option:not([disabled])');
        if (options.length > 0) {
          options[0].setAttribute('selected', '');
        }

      }
  });


  sector_select.addEventListener('change', () => {
    enableAllOptions(application_select);
    application_select.removeAttribute('disabled');
    // enable application select field and tom select
    application_select.tomselect.enable();
    const application = getApplications(sector_select.value);
    application_select.tomselect.clear(); // unselect previously selected elements
    application_select.tomselect.clearOptions(); // remove existing options
    application_select.tomselect.sync(); // synchronise with the underlying SELECT
    console.log('---application---', application);
    if (application.length > 0) {
      application_select.querySelectorAll('option').forEach(option => {
        if (application.indexOf(option.value) === -1) {
          option.setAttribute('disabled', '');
          option.setAttribute('hidden', '');
        }
      });

      application_select.tomselect.clear(); // unselect previously selected elements
      application_select.tomselect.clearOptions(); // remove existing options
      application_select.tomselect.clearCache(); // remove existing options
      application_select.tomselect.sync(); // synchronise with the underlying SELECT
    }
  })
}


const getIndustry = (sector) => {
  // find in sectors object property name == industry
  let founded_industry = [];

  Object.keys(industries).forEach(industry => {

    const founded = industries[industry].forEach(s => {

      if (s === sector) {
        founded_industry.push(industry);
      }
    });
  });
  console.log('---founded_industry---', founded_industry);
  return founded_industry;
}

const getSectors = (industry) => {

  if (!industries[industry]) {
    return [];
  } else {
    console.log('---founded_sectors---', industries[industry]);
    return industries[industry];
  };
}


const getApplications = (sector) => {
  let founded_app = null;
  Object.keys(applications).forEach(s => {
    if (s === sector) {
      founded_app = applications[s];
      return applications[s];
    }
  })

  return founded_app;
}

const enableAllOptions = (select) => {
  select.querySelectorAll('option').forEach(option => {
    option.removeAttribute('disabled');
    option.removeAttribute('hidden');
  });
}
